// extracted by mini-css-extract-plugin
module.exports =  {"seller-info":"AK5x5s4","sellerInfo":"AK5x5s4","compact-view":"jMMZXQj","compactView":"jMMZXQj","separation-ellipse":"BAkzDEn","separationEllipse":"BAkzDEn"};